var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/util/optional_motion.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Motion } from 'react-motion';
import { useSettings } from 'soapbox/hooks';
import ReducedMotion from './reduced_motion';
const OptionalMotion = props => {
  const reduceMotion = useSettings().get('reduceMotion');
  return reduceMotion ? /*#__PURE__*/React.createElement(ReducedMotion, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 20
    }
  })) : /*#__PURE__*/React.createElement(Motion, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 51
    }
  }));
};
export default OptionalMotion;